import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface CampaignLanguageWarningData {
  extraCountries: string[];
  extraLanguages: string[];
  advertiserId: string;
}

@Component({
  selector: 'app-campaign-language-warning-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Language/Country Mismatch</h2>
    <mat-dialog-content>
      <p>The following campaign settings are not in the advertiser's profile:</p>
      @if (data.extraCountries.length > 0) {
        <p><strong>Countries:</strong> {{ data.extraCountries.join(', ') }}</p>
      }
      @if (data.extraLanguages.length > 0) {
        <p><strong>Languages:</strong> {{ data.extraLanguages.join(', ') }}</p>
      }
      <p>
        You can <a [href]="advertiserProfileLink" target="_blank">update the advertiser profile</a>
        to include these settings, or proceed anyway.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">Proceed Anyway</button>
    </mat-dialog-actions>
  `
})
export class CampaignLanguageWarningDialogComponent {
  advertiserProfileLink: string;

  constructor(
    public dialogRef: MatDialogRef<CampaignLanguageWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignLanguageWarningData
  ) {
    this.advertiserProfileLink = `/advertiser/${data.advertiserId}`;
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
